<style type="text/css">
.dateTime {
  width: auto !important;
}

.dateTime .field-input {
  color: rgb(0, 168, 255) !important;
  padding: 2px !important;
  font-size: 12px !important;
  border: 0 !important;
}

.reset {
  display: flex;
  padding-top: 1em;
  padding-left: 0.5em;
}

.close-custom {
  font-size: 15px;
  transform: translateY(-50%);
}

.dateTime input::placeholder {
  color: rgb(0, 168, 255) !important;
  font-weight: 400;
}

.form-select {
  width: 160px;
  height: 2em;
  font-size: small;
}

.dynamic-actions {
  font-weight: bolder;
  width: 2em;
}

</style>
<template>
  <div class="dateTime position-relative">
    <div class="row justify-content-center">
      <div class="row">
        <select class="form-select" v-model="mode" @change="changeMode()">
          <option :value="FIXED_MODE">{{lang.fixed_date}}</option>
          <option :value="DYNAMIC_MODE">{{lang.current_date}}</option>
        </select>
        <div class="reset">
          <button class="close close-custom" @click="reset">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div v-if="actionType === 'create_record' && this.mode === this.DYNAMIC_MODE">
        <b-input-group size="sm" class="mb-1">
          <b-input-group-prepend>
            <span class="input-group-text" id="inputGroup-sizing-default">{{lang.days}}</span>
          </b-input-group-prepend>
          <b-form-input id="additional-days-input" type="number" v-model="dynamicDate.additionalDays"></b-form-input>
          <b-input-group-append>
            <b-button class="input-group-text dynamic-actions" @click="decrementDynamicDate('additionalDays')">-</b-button>
            <b-button class="input-group-text dynamic-actions" @click="incrementDynamicDate('additionalDays')">+</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group size="sm" class="mb-1" v-if="withTime">
          <b-input-group-prepend>
            <span class="input-group-text" id="inputGroup-sizing-default">Hours</span>
          </b-input-group-prepend>
          <b-form-input id="additional-days-input" type="number" v-model="dynamicDate.additionalHours"></b-form-input>
          <b-input-group-append>
            <b-button class="input-group-text dynamic-actions" @click="decrementDynamicDate('additionalHours')">-</b-button>
            <b-button class="input-group-text dynamic-actions" @click="incrementDynamicDate('additionalHours')">+</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group size="sm" class="mb-1" v-if="withTime">
          <b-input-group-prepend>
            <span class="input-group-text" id="inputGroup-sizing-default">Minutes</span>
          </b-input-group-prepend>
          <b-form-input id="additional-days-input" type="number" v-model="dynamicDate.additionalMinutes"></b-form-input>
          <b-input-group-append>
            <b-button class="input-group-text dynamic-actions" @click="decrementDynamicDate('additionalMinutes')">-</b-button>
            <b-button class="input-group-text dynamic-actions" @click="incrementDynamicDate('additionalMinutes')">+</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div v-if="actionType === 'create_record' && this.mode === this.FIXED_MODE" class="px-3">
        <VueCtkDateTimePicker
          :format="withTime ? setDynamicFormat() + ' HH:mm' : setDynamicFormat()"
          :formatted="withTime ? setDynamicFormat() + ' HH:mm' : setDynamicFormat()"
          v-model="dateTime"
          :no-label="true"
          :locale="lang.code"
          :button-now-translation="lang.now"
          :noClearButton="true"
          :label="lang.select + ' ' + lang.value"
          :only-date="!withTime"
          :position="'bottom'"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'level', // advanced condition level
    'mapping_for',
    'type',
    'field_type',
    'custom',
    'CreateRecordMapping',
    'actionType',
    'Auth',
    'lang',
  ],
  data() {
    return {
      DYNAMIC_MODE: 'DYNAMIC_MODE',
      FIXED_MODE: 'FIXED_MODE',
      mode: 'FIXED_MODE',
      withTime: false,
      dynamicDate: {
        additionalDays: 0,
        additionalHours: 0,
        additionalMinutes: 0,
      },
      previousDate: null,
      dateType: null,
      typesWithTime: ['datetime', 'datetimeDynamic'],
      dynamicTypes: ['dateDynamic', 'datetimeDynamic'],
    }
  },
  mounted() {

  },
  created() {
    this.withTime = this.typesWithTime.includes(this.mapping_for.type);
    this.dateType = this.withTime ? 'datetimeDynamic' : 'dateDynamic';
    if (this.mapping_for.field_type_dd !== undefined && this.mapping_for.field_type_dd !== null && this.mapping_for.field_type_dd !== '') {
      this.dateType = this.mapping_for.field_type_dd;
    }
    this.getMappedValue();
  },
  computed: {
    dateTime: {
      get() {
        return this.getMappedValue();
      },
      set(newVal) {
        this.getDateTime(newVal);
      }
    }
  },
  beforeMount() {

  },
  methods: {
    getDateTime(val) {
      if (val !== undefined) {
        let label = this.mode === this.DYNAMIC_MODE ? `Current date` : val;
        if (this.mode === this.FIXED_MODE) {
          this.previousDate = val;
        }
        let data = {
          mapping_for: {...this.mapping_for, type: this.dateType},
          selected_field: {
            'name': val,
            'label': label,
            'id': null,
            'field_type_dd': this.dateType,
          },
          record_type: 'custom',
        };

        this.$emit('CreateRecordOptionSelectedEvent', data);
      }
    },
    getMappedValue() {
      let dateTimeDetails = null;
      if (this.CreateRecordMapping.length > 0) {
        let _index = this.CreateRecordMapping.findIndex(x => x.mapping_for_id === this.mapping_for.id);
        let currentFieldMapping = this.mapping_for;
        if (_index > -1) {
          currentFieldMapping = this.CreateRecordMapping[_index];
          dateTimeDetails = this.CreateRecordMapping[_index].mapped_with_name;
        }
        this.dateType = currentFieldMapping.field_type_dd ? currentFieldMapping.field_type_dd : currentFieldMapping.type;
        this.withTime = this.typesWithTime.includes(this.dateType);
        this.mode = this.dynamicTypes.includes(this.dateType) ? this.DYNAMIC_MODE : this.FIXED_MODE;
        if (this.mode === this.DYNAMIC_MODE) {
          this.dynamicDate = dateTimeDetails;
        } else {
          this.previousDate = dateTimeDetails;
        }
      }
      return dateTimeDetails;
    },
    setDynamicFormat() {
      switch (this.Auth.formatting.date_order) {
        case 'd-m-Y':
          return this.setDateSeparator('DD-MM-YYYY');
          break;
        case 'm-d-Y':
          return this.setDateSeparator('MM-DD-YYYY');
          break;
        case 'Y-m-d' :
          return this.setDateSeparator('YYYY-MM-DD');
          break;
        case 'Y-d-m' :
          return this.setDateSeparator('YYYY-DD-MM');
          break;
        default :
          return this.setDateSeparator('DD-MM-YYYY');
      }
    },
    setDateSeparator(format) {
      if (this.Auth.formatting.date_separator) {
        let _separator = this.Auth.formatting.date_separator;
        return format.replace(/-/g, _separator);
      } else {
        return format;
      }
    },
    incrementDynamicDate (parameter) {
      if (this.dynamicDate[parameter] !== undefined) {
        this.dynamicDate[parameter] = +this.dynamicDate[parameter] + 1;
        this.getDateTime(this.dynamicDate);
      }
    },
    decrementDynamicDate (parameter) {
      if (this.dynamicDate[parameter] !== undefined) {
        this.dynamicDate[parameter] = +this.dynamicDate[parameter] - 1;
        this.getDateTime(this.dynamicDate);
      }
    },
    changeMode () {
      if (this.mode === this.DYNAMIC_MODE) {
        this.dateType = this.withTime ? 'datetimeDynamic' : 'dateDynamic';
        this.getDateTime(this.dynamicDate);
      } else {
        this.dateType = this.withTime ? 'datetime' : 'date';
        this.getDateTime(this.previousDate);
      }
    },
    reset() {
      this.mode = this.DYNAMIC_MODE;
      this.dynamicDate = {
        additionalDays: 0,
        additionalHours: 0,
        additionalMinutes: 0,
      };
      this.previousDate = null;
      this.$emit('removeSelectedItemEvent');
    }
  }
}
</script>
